import { SectionQuickMenuDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import styled from '@emotion/styled';
import { SectionTitle } from 'app-components/home/sections/components/SectionTitle';
import { useTrackingState } from 'contexts/TrackingProvider';
import React, { useCallback } from 'react';
import {
  QuickMenuType,
  TrackerExtraInfoProps,
  TrackingEventType,
} from '@diritto/common/tracker/tracking-event.constant';
import { Color } from '@diritto/common/style/color';
import { PurpleHeartIcon } from 'icons/emoji/PurpleHeartIcon';
import { CheckMarkButtonIcon } from 'icons/emoji/CheckMarkButtonIcon';
import { TrophyIcon } from 'icons/emoji/TrophyIcon';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { Link } from 'ui-components/common/Link';

type SectionProps = {
  section: SectionQuickMenuDto;
};
export const SectionQuickMenu = ({ section, trackerExtraInfo }: SectionProps & TrackerExtraInfoProps) => {
  const { tracker } = useTrackingState();
  const handleOnClickTracker = useCallback(
    (quickMenu: QuickMenuType) => {
      tracker.track(TrackingEventType.ClickSectionQuickMenu, { quickMenu });
    },
    [tracker],
  );
  return (
    <div>
      <SectionTitle section={section} moreLink={section.moreLink} trackerExtraInfo={trackerExtraInfo} />
      <StyledWrapper>
        <StyleEventQuickMenu href="/events" onClick={() => handleOnClickTracker(QuickMenuType.Event)}>
          <PurpleHeartIcon />
          이벤트
        </StyleEventQuickMenu>
        <StyleAttendanceCheckQuickMenu
          href="/quest/attendance-check"
          onClick={() => handleOnClickTracker(QuickMenuType.AttendanceCheck)}>
          <CheckMarkButtonIcon />
          출석체크
        </StyleAttendanceCheckQuickMenu>
        <StyleActivityPointRankQuickMenu
          href="/quest/ranking"
          onClick={() => handleOnClickTracker(QuickMenuType.QuestRank)}>
          <TrophyIcon />
          퀘스트 랭킹
        </StyleActivityPointRankQuickMenu>
      </StyledWrapper>
    </div>
  );
};
export default SectionQuickMenu;
const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
`;
const StyleQuickMenu = styled(Link)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  gap: 6px;
  font-weight: ${FontWeight.Bold};
  ${Typography.XXSmall};
`;
const StyleEventQuickMenu = styled(StyleQuickMenu)`
  background-color: ${Color.Primary100};
  color: ${Color.Primary500};
`;
const StyleAttendanceCheckQuickMenu = styled(StyleQuickMenu)`
  background-color: ${Color.Green100};
  color: ${Color.Green500};
`;
const StyleActivityPointRankQuickMenu = styled(StyleQuickMenu)`
  background-color: ${Color.Orange100};
  color: ${Color.Orange500};
`;
